import { createLazyRoute } from '@core/router';
import { Route } from 'react-router-dom';
import React from 'react';

const homePageRoute = () => import('./HomePage');

const homeRoutes = <Route path="pro" {...createLazyRoute(homePageRoute, m => m.default)} />;

export default homeRoutes;
